package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository

actual suspend fun Repository.getWalletConnected(): Boolean = withRepoContext {
    return@withRepoContext web3Provider?.getActiveAccountAddress() != null
}